<template>
  <div class="designfile-list">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-toolbar class="my-md-auto nobackground" elevation="0"  >
          <v-toolbar-title class="" >
            <h1><v-icon large>mdi-file-cad</v-icon>{{$t('designfile.designfiles')}} -
              <span v-if="type">
                <span v-if="language == 'fr'">{{ type.namefr }}</span>
                <span v-else>{{ type.name }}</span>
              </span>

            </h1>
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            :loading="isLoading"
            class="ml-sm-2"
            color="primary"
            v-if="userHasAccess('designfile_edit')"
            @click="addHandler"
          >
            {{ $t('global.add')}}
          </v-btn>
        </v-toolbar>
        <v-flex lg12>
          <v-container>
            <v-row>
              <v-col cols="12" sm="3" md="3" v-for="item in items" :key="item.id">
                <v-card class="black" >
                  <v-img
                    v-if="item['image']"
                    max-height="150"
                    @click="showHandler(item)"
                    class="white--text align-end cursorpointer "

                    :key="getItemImageKey(item)"
                    contain
                    :src="getImageUrlByObject(item)"
                  >

                   </v-img>
                   <v-img v-else height="150" contain @click="showHandler(item)" class="white--text align-center align-end cursorpointer  text-center" >
                     <p class="textsize20 text-uppercase ma-5 familyGTAmerica" >{{ $t('global.nopicture') }}<br>{{ $t('global.available') }}</p>
                   </v-img>
                   <v-card-actions class="bordertop_white">
                     <span class="ml-4 d-inline-block text-truncate" v-if="language == 'fr'">{{ item.namefr }}</span>
                     <span class="ml-4 d-inline-block text-truncate" v-else>{{ item.name }}</span>
                     <v-spacer></v-spacer>
                     <v-btn  icon  x-large  @click="showHandler(item)">
                       <v-icon >mdi-launch</v-icon>
                     </v-btn>
                   </v-card-actions>
                 </v-card>
              </v-col>
            </v-row>
            <div class="text-center">
              <v-pagination
                v-model="page"
                :length="pageTotal"
                :total-visible="5"
                circle
              ></v-pagination>
            </div>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import FileMixin from '../../mixins/FileMixin';
import AccessMixin from '../../mixins/AccessMixin';


export default {
  name: 'DesignFileList',
  servicePrefix: 'DesignFile',
  mixins: [ListMixin,AccessMixin,FileMixin],
  components: {

  },
  data() {
    return {
      filter: '400x400',
      selected: [],
      filters: {
        'type' : this.$route.params.id,
      },
      pageData : 1,

    };
  },
  mounted() {
    this.options.page = this.page;
    this.options.itemsPerPage = 12;
    this.onUpdateOptions(this.options);
//    this.getPage();
  },
  created() {
    this.retrieve(decodeURIComponent('/api/design_file_types/' +this.$route.params.id));
  },
  computed: {
    ...mapGetters('designfile', {
      items: 'list'
    }),
    ...mapGetters('designfiletype', {
      find: 'find'
    }),
    ...mapFields('designfile', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    ...mapFields('designfile', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    page: {
      get() { return this.pageData },
       set(value) { this.pageData = value; }
    },
    pageTotal() {
      return Math.ceil(this.totalItems / this.options.itemsPerPage);
    },
    type() {
      return this.find(decodeURIComponent('/api/design_file_types/' + this.$route.params.id));
    },
    language() {
      return i18n.locale;
    }
  },
  methods: {
    ...mapActions('designfile', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    ...mapActions('designfiletype', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
  },
  watch: {
    page() {
      this.options.page = this.page;
      this.onUpdateOptions(this.options);
    }
  }
};
</script>
